import React from 'react';

import CommonImage from '@components/CommonImage';

import Chip from '@features/filter/Chip';

const FilterTopHeader = ({ showFilterButton = true, toggleFilter, totalItem = 0 }) => {
	return (
		<div className="filter-container-top filter-container-top-v2 bg-white p-0">
			<div className="filters">
				{showFilterButton && (
					<div className="filter-toggle" onClick={toggleFilter}>
						<CommonImage src="/icons/filter24.svg" alt="filter" />
						<CommonImage src="/icons/filter-close.svg" alt="filter" className="d-none" />
						<span>Filter</span>
					</div>
				)}
				<span className="items-count semibold-14 gray_dark_02">
					{totalItem > 0 ? `${totalItem} items` : `${totalItem} item`}
				</span>
				<Chip />
			</div>
		</div>
	);
};

export default FilterTopHeader;
